module.exports = __webpack_public_path__ + "img/real-example.60c76e3.webp";